// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Location.proto" (package "aware", syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf enum aware.PlaceSource
 */
export var PlaceSource;
(function (PlaceSource) {
    /**
     * @generated from protobuf enum value: UnspecifiedPlaceSource = 0;
     */
    PlaceSource[PlaceSource["UnspecifiedPlaceSource"] = 0] = "UnspecifiedPlaceSource";
    /**
     * @generated from protobuf enum value: UserInput = 1;
     */
    PlaceSource[PlaceSource["UserInput"] = 1] = "UserInput";
    /**
     * @generated from protobuf enum value: ObservedVisit = 2;
     */
    PlaceSource[PlaceSource["ObservedVisit"] = 2] = "ObservedVisit";
    /**
     * @generated from protobuf enum value: CalendarLocationString = 3;
     */
    PlaceSource[PlaceSource["CalendarLocationString"] = 3] = "CalendarLocationString";
})(PlaceSource || (PlaceSource = {}));
// @generated message type with reflection information, may provide speed optimized methods
class LocationMeasurement$Type extends MessageType {
    constructor() {
        super("aware.LocationMeasurement", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "altitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "ellipsoidal_altitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "horizontal_accuracy", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "vertical_accuracy", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "floor_level", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.LocationMeasurement
 */
export const LocationMeasurement = new LocationMeasurement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VelocityMeasurement$Type extends MessageType {
    constructor() {
        super("aware.VelocityMeasurement", [
            { no: 1, name: "speed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "course", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.VelocityMeasurement
 */
export const VelocityMeasurement = new VelocityMeasurement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocationUpdate$Type extends MessageType {
    constructor() {
        super("aware.LocationUpdate", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "location_measurement", kind: "message", T: () => LocationMeasurement },
            { no: 4, name: "velocity_measurement", kind: "message", T: () => VelocityMeasurement }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.LocationUpdate
 */
export const LocationUpdate = new LocationUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocationVisit$Type extends MessageType {
    constructor() {
        super("aware.LocationVisit", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "arrival_date", kind: "message", T: () => Timestamp },
            { no: 3, name: "departure_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "location_measurement", kind: "message", T: () => LocationMeasurement }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.LocationVisit
 */
export const LocationVisit = new LocationVisit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Geolocation$Type extends MessageType {
    constructor() {
        super("aware.Geolocation", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "altitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "location_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.Geolocation
 */
export const Geolocation = new Geolocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeolocationVelocity$Type extends MessageType {
    constructor() {
        super("aware.GeolocationVelocity", [
            { no: 1, name: "latitude_velocity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "longitude_velocity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "altitude_velocity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "latitude_velocity_m", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "longitude_velocity_m", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.GeolocationVelocity
 */
export const GeolocationVelocity = new GeolocationVelocity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeolocationRegion$Type extends MessageType {
    constructor() {
        super("aware.GeolocationRegion", [
            { no: 1, name: "center", kind: "message", T: () => Geolocation },
            { no: 2, name: "radius_m", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.GeolocationRegion
 */
export const GeolocationRegion = new GeolocationRegion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AwareSpaceLocation$Type extends MessageType {
    constructor() {
        super("aware.AwareSpaceLocation", [
            { no: 1, name: "space_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "region_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.AwareSpaceLocation
 */
export const AwareSpaceLocation = new AwareSpaceLocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Placemark$Type extends MessageType {
    constructor() {
        super("aware.Placemark", [
            { no: 1, name: "location", kind: "message", T: () => Geolocation },
            { no: 2, name: "iso_country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "administrative_area", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "sub_administrative_area", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "locality", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "sub_locality", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "thoroughfare", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "sub_thoroughfare", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "region_radius", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "inland_water", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "ocean", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "areas_of_interest", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.Placemark
 */
export const Placemark = new Placemark$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlaceDisplayName$Type extends MessageType {
    constructor() {
        super("aware.PlaceDisplayName", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "source", kind: "enum", T: () => ["aware.PlaceSource", PlaceSource] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.PlaceDisplayName
 */
export const PlaceDisplayName = new PlaceDisplayName$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Place$Type extends MessageType {
    constructor() {
        super("aware.Place", [
            { no: 1, name: "place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "geolocation_region", kind: "message", T: () => GeolocationRegion },
            { no: 3, name: "owner_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "display_names", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PlaceDisplayName },
            { no: 5, name: "aware_space_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "place_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "creation_source", kind: "enum", T: () => ["aware.PlaceSource", PlaceSource] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.Place
 */
export const Place = new Place$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Route$Type extends MessageType {
    constructor() {
        super("aware.Route", [
            { no: 1, name: "route_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "start_place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "end_place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "owner_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "start_place", kind: "message", T: () => Place },
            { no: 101, name: "end_place", kind: "message", T: () => Place }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.Route
 */
export const Route = new Route$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPlaces$Type extends MessageType {
    constructor() {
        super("aware.UserPlaces", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "places", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Place },
            { no: 3, name: "routes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Route },
            { no: 4, name: "default_place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserPlaces
 */
export const UserPlaces = new UserPlaces$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CityStateCountryInfo$Type extends MessageType {
    constructor() {
        super("aware.CityStateCountryInfo", [
            { no: 1, name: "city_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "state_abbreviation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "country_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "country_abbreviation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "full_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "query_location", kind: "message", T: () => Geolocation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.CityStateCountryInfo
 */
export const CityStateCountryInfo = new CityStateCountryInfo$Type();
/**
 * @generated ServiceType for protobuf service aware.FakeServiceLocation
 */
export const FakeServiceLocation = new ServiceType("aware.FakeServiceLocation", [
    { name: "Bar", options: {}, I: Empty, O: Empty }
]);
